import { useState, useCallback, useEffect } from 'react'
import { email } from '../store/store'

const storageName = 'userData'

export const useAuth = () => {
  const [token, setToken] = useState(null)
  const [expire, setExpire] = useState(null)
  const [ready, setReady] = useState(false)
  const [userId, setUserId] = useState(null)

  useEffect(() => {
    const interval = setInterval(() => {
      console.log(`initializing interval`);
      const data = JSON.parse(localStorage.getItem(storageName))

      if (data && data.token && data.expire > Date.now() / 1000) {
        // login(data.token, data.userId, data.expire, data.email)
      }else{
        logout()
      }
    }, 60000);

    return () => {
      console.log(`clearing interval`);
      clearInterval(interval);
    };
  }, []);

  const login = useCallback((jwtToken, id, expire, emailUser) => {
    setToken(jwtToken)
    setUserId(id)
    setExpire(expire)
    email(emailUser)
    localStorage.setItem(storageName, JSON.stringify({
      userId: id, token: jwtToken, expire: expire, email: emailUser
    }))
  }, [])


  const logout = useCallback(() => {
    setToken(null)
    setUserId(null)
    setExpire(null)
    email('')

    localStorage.removeItem(storageName)
  }, [])

  useEffect(() => {
    const data = JSON.parse(localStorage.getItem(storageName))

    if (data && data.token && data.expire > Date.now() / 1000) {
      login(data.token, data.userId, data.expire, data.email)
    }
    setReady(true)
  }, [login])


  return { login, logout, token, userId, expire, ready }
}